import { Box, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';

import { useCopilotTrial } from 'utils/useCopilotTrial';

import { PlaceholderPage } from '../SuggestionList';

import styles from './Article.module.scss';

function ArticleActionsPlaceholder() {
  const { hasCopilot } = useCopilotTrial();
  return (
    <FlexBox width="100%" padding="0 0 28px" gap="300">
      <Icon className={styles.icon} name="arrow-left" />
      <Box className={styles.grow}>
        <Text.Paragraph className={styles.results} variant="3">
          Results
        </Text.Paragraph>
      </Box>
      {hasCopilot && <PlaceholderPage />}
      <PlaceholderPage />
      <PlaceholderPage />
    </FlexBox>
  );
}

function ArticleBodyPlaceholder() {
  return (
    <FlexBox flexDirection="column" gap="22px">
      <Box width="160px" height="16px" className={styles.placeholder} />
      <FlexBox flexDirection="column" gap="8px">
        {Array.from(new Array(4)).map((_, i) => (
          <FlexBox key={i} gap="6px" alignItems="center">
            <Box width="12px" height="12px" className={styles.placeholder} />
            <Box width="80px" height="8px" className={styles.placeholder} />
          </FlexBox>
        ))}
      </FlexBox>
      <FlexBox flexDirection="column" gap="8px">
        {Array.from(new Array(11)).map((_, i) => (
          <Box
            width="100%"
            height="12px"
            key={i}
            className={styles.placeholder}
          ></Box>
        ))}
      </FlexBox>
    </FlexBox>
  );
}

export function ArticlePlaceholder(): JSX.Element {
  return (
    <Box>
      <ArticleActionsPlaceholder />
      <ArticleBodyPlaceholder />
    </Box>
  );
}
